import { z } from 'zod';
export const MESSAGE_TEXT_MAX_LENGTH = 4000;
export const textContentSchema = z.strictObject({
    kind: z.literal('text'),
    text: z.string().min(1).max(MESSAGE_TEXT_MAX_LENGTH),
});
export const MESSAGE_SUMMARY_MAX_LENGTH = 200;
export const cardContentSchema = z.strictObject({
    kind: z.literal('card'),
    /** JSON de um Adaptive Card, repassado ao Teams sem transformação. */
    card: z.record(z.string(), z.unknown()),
    /**
     * Texto mostrado na notificação e na lista de chats, onde o card não é
     * renderizado. Sem ele, o Teams mostra só "Enviou um cartão".
     */
    summary: z.string().min(1).max(MESSAGE_SUMMARY_MAX_LENGTH).optional(),
});
export const messageContentSchema = z.discriminatedUnion('kind', [
    textContentSchema,
    cardContentSchema,
]);
export const sendMessageRequestSchema = z.strictObject({
    recipientEmail: z.email(),
    content: messageContentSchema,
});
export const sendMessageResponseSchema = z.strictObject({
    deliveryId: z.uuid(),
    activityId: z.string().min(1),
    attempts: z.int().positive(),
});
//# sourceMappingURL=send-message.contract.js.map